import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '../../admin/Constant'


export const PackageTypeApi = createApi({
    reducerPath: 'PackageTypeApi',
    baseQuery: fetchBaseQuery({baseUrl: API_URL}),
    endpoints: (builder) => ({
        addPackage: builder.mutation({
            query: (data) => ({
             url: `package-types/create`,
             method: "POST",
             body: data
            })
         }),
        allPackageType: builder.query({
            query: () => ({
            url: "package-types/all",
            method: "GET",
            })
         }),
        getPackageType: builder.query({
            query: (id) => ({
            url: `package-types/view/${id}`,
            method: "GET",
            })
         }),
        deletePackageType: builder.mutation({
            query: (id) => ({
            url: `package-types/delete/${id}`,
            method: "DELETE",
            })
         }),
         updatePackage: builder.mutation({
            query: (data) => ({
             url: `package-types/update`,
             method: "PUT",
             body: data
            })
         }),
         }),
})

export const { 
              useAllPackageTypeQuery, 
              useAddPackageMutation, 
              useDeletePackageTypeMutation, 
              useGetPackageTypeQuery, 
              useUpdatePackageMutation 
            } = PackageTypeApi